$(document).ready(function(){
  $('body').on('change','#product-custom-checkbox',function(e){
    e.preventDefault();
    if($(this).prop('checked')){
      console.log('checked');
      var gid = parseInt($('#product-custom-checkbox').attr('data-product-id'));
      $('product-form .default-product-variant-id').attr('name','id[]');
      $('product-form .default-product-variant-id').after('<input type="hidden" name="id[]" value="'+gid+'" class="productgiftwrap-variant-id">');
    }else{
      $('.productgiftwrap-variant-id').remove();
      $('product-form .default-product-variant-id').attr('name','id');
      console.log('Unchecked');
    }
  });
});